export const onSortValue = ['treatment_name', 'Status', 'Contact'];

export const TAB_HEAD = [
    { value: 'All', label: 'All' },
    { value: 'NEW', label: 'New' },
    { value: 'CONSULTATION_BOOKED', label: 'Consultation booked' },
    { value: 'CONSULTATION_ATTENDED', label: 'Consultation attended' },
    { value: 'TREATMENT_STARTED', label: 'Treatment started' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'FTA' },
    { value: 'CLOSED', label: 'Completed' }
];

export const TAB_HEAD_FOLLOW_UP = [
    { value: 'All', label: 'All' },
    { value: 'NEW', label: 'New' },
    { value: 'FOLLOW_UP', label: 'Follow up' },
    { value: 'CONSULTATION_BOOKED', label: 'Consultation booked' },
    { value: 'CONSULTATION_ATTENDED', label: 'Consultation attended' },
    { value: 'TREATMENT_STARTED', label: 'Treatment started' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'FTA' },
    { value: 'CLOSED', label: 'Completed' }
];

export const TAB_HEAD_NO_TASK = [
    { value: 'NEW', label: 'New' },
    { value: 'FOLLOW_UP', label: 'Follow up' },
    { value: 'CONSULTATION_BOOKED', label: 'Consultation booked' },
    { value: 'CONSULTATION_ATTENDED', label: 'Consultation attended' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'FTA' },
];

export const NEW_TAB_HEAD = [
    { value: '0', label: 'New' },
    { value: '1', label: 'Follow up 1' },
    { value: '2', label: 'Follow up 2' },
    { value: '3', label: 'Follow up 3 +' },
];

export const DASHBOARD_WIDGET_COUNTER = [
    { key: '1', status: 'NEW', isDate: true, healthCareProvider: 'PRIVATE', hasNewOrNullTreatment: true },
    { key: '2', group__in: true, completedFilter: true, isTaskDateTimeRange: true, shouldGetTaskCounter: true, is_completed: false, dateFilters: 'Today' },
    { key: '3', shouldGetReportCounter: true, status: 'CONSULTATION_BOOKED', status__in: 'BOOKED' },
    { key: '4', status: 'CONSULTATION_ATTENDED', isAppointmentDate: true, contactedCountForStatus: '0,exact,CONSULTATION_ATTENDED' },
    { key: '5', status: 'CONSULTATION_ATTENDED', isClinCheckTable: true, clinCheckStatus: 'IN_PROGRESS,UPLOADED', isAppointmentDate: true },
    { key: '6', status: 'FAILED_TO_ATTEND_CONSULTATION' },
    { key: 'BOOKED_AWAITING', status: 'CONSULTATION_BOOKED', appStatus: 'BOOKED', pastNoOutcome: true },
    // key '7' (Pending WhatsApps) is populated by fetchUnreadWhatsAppCount() in whatsappV2.js
    // — do NOT add it here or it will race-overwrite the real WhatsApp thread counts.
];

const appointmentDataAttendedTable = { appStatus: 'ATTENDED' };

// Actionable widget counters for Consultation Booked table
export const BOOKED_TABLE_WIDGET_COUNTER = [
    { key: 'upcoming', status: 'CONSULTATION_BOOKED', appStatus: 'BOOKED', upcomingThisWeek: true },
    { key: 'past', status: 'CONSULTATION_BOOKED', appStatus: 'BOOKED', pastNoOutcome: true },
];
export const STARTED_TABLE_WIDGET_COUNTER = [
    { key: '1', treatmentStatusForPrice: 'TREATMENT_STARTED', treatmentPrice: true },
    { key: '2', status: 'TREATMENT_STARTED', treatment: 'invisalign' },
    { key: '3', status: 'TREATMENT_STARTED', treatment: 'bonding' },
    { key: '4', status: 'TREATMENT_STARTED', treatment: 'implants' },
    { key: '5', status: 'TREATMENT_STARTED', treatment: 'whitening' },
    { key: '6', status: 'TREATMENT_STARTED', appStatus: 'BOOKED', isAppointmentDate: true },
    { key: '7', status: 'TREATMENT_STARTED', treatment: 'veneers' },
    { key: '8', status: 'TREATMENT_STARTED', treatment: 'all on 4' },
    { key: '9', status: 'TREATMENT_STARTED', treatment: 'teeth straightening' },
    { key: '10', status: 'TREATMENT_STARTED', treatment: 'fixed braces' },
];
export const FTA_TABLE_WIDGET_COUNTER = [
    { key: '1', status: 'FAILED_TO_ATTEND_CONSULTATION' },
    { key: '2', status: 'FAILED_TO_ATTEND_CONSULTATION', treatment: 'invisalign' },
    { key: '3', status: 'FAILED_TO_ATTEND_CONSULTATION', treatment: 'bonding' },
    { key: '4', status: 'FAILED_TO_ATTEND_CONSULTATION', treatment: 'implants' },
];
export const ATTENDED_TABLE_WIDGET_COUNTER = [
    { key: '1', status: 'CONSULTATION_ATTENDED', contactedCountForStatus: '0,exact,CONSULTATION_ATTENDED' },
    { key: '2', status: 'CONSULTATION_ATTENDED', treatment: 'invisalign', ...appointmentDataAttendedTable },
    { key: '3', status: 'CONSULTATION_ATTENDED', treatment: 'bonding', ...appointmentDataAttendedTable },
    { key: '4', status: 'CONSULTATION_ATTENDED', treatment: 'implants', ...appointmentDataAttendedTable },
    { key: '5', status: 'CONSULTATION_ATTENDED', treatment: 'whitening', ...appointmentDataAttendedTable },
    { key: '6', treatmentStatusForPrice: 'CONSULTATION_ATTENDED', shouldGetPrice: true, appStatusForPrice: 'ATTENDED' },
];
export const CLINCHECK_TABLE_WIDGET_COUNTER = [
    { key: '1', isClinCheckTable: true, status: 'CONSULTATION_ATTENDED' },
    { key: '2', isClinCheckTable: true, status: 'CONSULTATION_ATTENDED', treatment: 'invisalign' },
    { key: '3', isClinCheckTable: true, status: 'CONSULTATION_ATTENDED', treatment: 'bonding' },
    { key: '4', isClinCheckTable: true, status: 'CONSULTATION_ATTENDED', treatment: 'implants' },
    { key: '5', isClinCheckTable: true, status: 'CONSULTATION_ATTENDED', treatment: 'whitening' },
    { key: '6', isClinCheckTable: true, status: 'CONSULTATION_ATTENDED', shouldGetPrice: true },
];

export const CONSULTANT_NEW_ATTENDED_HEAD = [
    { value: '0', label: 'New' },
    { value: '1', label: 'Follow up 1' },
    { value: '2', label: 'Follow up 2' },
    { value: '3', label: 'Follow up 3 +' },
];

// Single "All Attended" tab — used by the ConsultantAttend table to show every attended
// lead regardless of contacted-count. Kept separate from CONSULTANT_NEW_ATTENDED_HEAD so
// that NHSLead.jsx and tasksV2.js (which spread the original 4-entry array) are unaffected.
export const CONSULTANT_ATTENDED_SINGLE_HEAD = [{ value: 'All', label: 'All Attended' }];

// Shared query-string builder for the attended contacted-count filter.
// Emits status-scoped params so only contacts logged during CONSULTATION_ATTENDED
// are matched — prevents false positives from cross-status count rows.
// Consumed by: ConsultantAttend.jsx (fallback) and NewLead.jsx (useAttendedScope branch).
export const buildAttendedCountFilterQuery = (val) => {
    if (!val) return '';
    if (val === '3+') return '&contacted_count_for_status=3,gte,CONSULTATION_ATTENDED';
    return `&contacted_count_for_status=${val},exact,CONSULTATION_ATTENDED`;
};

export const CONSULTANT_CLINCHECK_ATTENDED_HEAD = [];

export const ATTENDED_CHECKLISTS_HEAD = [];

export const ATTENDED_CHECKLISTS_TAB_HEAD = [
    { value: 'in_progress', label: 'In Progress' },
    // Canonical BE value is 'complete' (apps/leads/filters.py VALID_CHECKLIST_STATES =
    // {'complete','in_progress','none'}). Strip value is the BE value directly — single
    // source of truth, no FE-side 'completed'→'complete' normalization anywhere.
    { value: 'complete', label: 'Follow-Up Complete' },
];

// Mitigation LIFTED 2026-05-27: BE #9 (checklist-state COUNT query optimisation) is in
// production.  The count query (limit=1&checklist_state=in_progress|complete) now returns
// in ~100-200 ms (measured on prod: p18 Wokingham 14/12, p26 DentalKind 8/2).
// Setting this back to false re-enables the existing getCounter path for the "In Progress"
// and "Follow-Up Complete" checklist sub-tabs (same mechanism as Follow-up 1/2/3; no new
// logic — the counter wiring already exists, it was only gated by this flag).
// Original suppression reason: task #10 / feature_fix-leads-tab-refire (ERR_ABORTED storm).
export const SUPPRESS_CHECKLIST_TAB_COUNTERS = false;

export const CONSULTANT_BOOKED_HEAD = [];

export const DASH_NEW_HEADER = [
    { value: '0', label: 'New' },
    { value: 'NHS', label: 'NHS' },
    { value: 'AWAITING_RESPONSE', label: 'Waiting/Scheduled' },
    { value: '1', label: 'Follow up 1' },
    { value: '2', label: 'Follow up 2' },
    { value: '3', label: 'Follow up 3 +' },
];
// notification
export const NOTIFICATION_HEAD = [
    { id: '' },
    { id: 'description', label: 'Description', sort: '' },
    { id: 'timestamp', label: 'Timestamp', sort: '' },
    { id: '' },
];

export const NOTIFICATION_HEAD_SETTING = [
    { id: 'notify', label: 'Notify', sort: '' },
    { id: 'platform', label: 'Platform', sort: '', checkbox: true },
    { id: 'email', label: 'Email', sort: '', checkbox: true },
    { id: 'sms', label: 'SMS', sort: '', checkbox: true },
    { id: '' },
];

export const DATE_TITLES = [
    {
        label: 'Date',
        value: 'date_format',
        icon: 'solar:calendar-mark-bold-duotone'
    },
    {
        label: 'Time',
        value: 'human_readable',
        icon: 'uim:clock'
    },
    {
        label: 'Date & Time',
        value: 'date_time_format',
        icon: 'mdi:calendar-clock'
    },
];

export const COLOR_CODES = [
    '#D1E9FC',
    '#76B0F1',
    '#2065D1',
    '#103996',
    '#061B64',
    '#EFD6FF',
    '#C684FF',
    '#8E33FF',
    '#5119B7',
    '#27097A',
    '#CAFDF5',
    '#61F3F3',
    '#00B8D9',
    '#006C9C',
    '#003768',
    '#D3FCD2',
    '#77ED8B',
    '#22C55E',
    '#118D57',
    '#065E49',
    '#FFF5CC',
    '#FFD666',
    '#FFAB00',
    '#B76E00',
    '#7A4100',
    '#FFE9D5',
    '#FFAC82',
    '#FF5630',
    '#B71D18',
    '#7A0916',
    '#F9FAFB',
    '#F4F6F8',
    '#DFE3E8',
    '#C4CDD5',
    '#919EAB',
    '#6E7E91',
];

export const startedTreatmentColumns = ['treatment', 'price', 'status', 'lead_treatments__appointments__datetime', 'booked_with', 'actions',];
export const bookedAttendedColumns = ['treatment', 'price', 'status', 'deposit_pending', 'app_method', 'app_type', 'lead_treatments__appointments__datetime', 'actions'];
export const commonColumns = ['treatment', 'status', 'price', 'actions'];